const items = ["QUALIDADE 4K", "SEM TRAVAMENTOS", "SUPORTE 24/7", "+100.000 CONTEÚDOS", "ACESSO IMEDIATO", "MULTI-DISPOSITIVOS"];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="relative border-y border-white/5 bg-[#0F0F1A] py-6">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl font-black uppercase tracking-tight text-stroke md:text-3xl">
              {t}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#8B5CF6]" />
          </div>
        ))}
      </div>
    </div>
  );
};
